document.addEventListener("DOMContentLoaded", function() {
  // YouTube Data Fetch
  const apiKey = 'AIzaSyA7fnghb0ffBUQjWEaBAbS_vTw5jDOUrlg';  // Replace with your API key
  const videoBlocks = document.querySelectorAll('.video');

  videoBlocks.forEach(videoBlock => {
    const videoId = videoBlock.getAttribute('data-video-id');
    const apiUrl = `https://www.googleapis.com/youtube/v3/videos?part=statistics,snippet&id=${videoId}&key=${apiKey}`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data.items.length > 0) {
          const viewCount = data.items[0].statistics.viewCount;
          const uploadDate = data.items[0].snippet.publishedAt;

          // Update data attributes for sorting
          videoBlock.setAttribute('data-popularity', viewCount);
          videoBlock.setAttribute('data-date', new Date(uploadDate).toISOString().split('T')[0]);
        } else {
          console.error(`No data returned for videoId: ${videoId}`);
        }
      })
      .catch(error => console.error('Error fetching YouTube data:', error));
  });

  // Sorting script
  document.getElementById("sort-popular").addEventListener("click", function() {
    sortVideos("popular");
  });

  document.getElementById("sort-latest").addEventListener("click", function() {
    sortVideos("latest");
  });

  function sortVideos(criteria) {
    const videoList = document.getElementById("video-list");
    const videos = Array.from(videoList.getElementsByClassName("video"));

    if (criteria === "popular") {
      videos.sort((a, b) => b.getAttribute("data-popularity") - a.getAttribute("data-popularity"));
    } else if (criteria === "latest") {
      videos.sort((a, b) => new Date(b.getAttribute("data-date")) - new Date(a.getAttribute("data-date")));
    }

    videoList.innerHTML = ""; // Clear current videos
    videos.forEach(video => videoList.appendChild(video)); // Append sorted videos
  }

  // Load More Button functionality
  const loadMoreButton = document.getElementById("load-more");
  let currentlyVisible = 6;  // Show 6 videos initially

  loadMoreButton.addEventListener("click", function() {
    const videoList = document.querySelectorAll("#video-list .video");

    // Reveal next 6 videos
    currentlyVisible += 6;
    videoList.forEach((video, index) => {
      if (index < currentlyVisible) {
        video.style.display = 'block';  // Show more videos
      }
    });

    // Hide the "Load More" button if all videos are visible
    if (currentlyVisible >= videoList.length) {
      loadMoreButton.style.display = 'none';
    }
  });
});
